<template>
    <h3 class="timelineHeader">
        {{ header }}
    </h3>
</template>

<script>
export default {
    name: 'TimelineStep',

    props: {
        header: {
            type: String,
            required: true,
        },
    },
}
</script>

<style lang="stylus">
.timelineHeader {
    align-items: center;
    display: flex;
    margin: 0 0 0 $cs-spaces.half;

    @media $display-breakpoints.sm-and-up {
        margin: 0 0 0 $cs-spaces.onehalf;
    }
}
</style>
